
import styles from './log-out-dialog.module.css';
import { useNavbarIconUrl } from '@shared/lib/hooks';
import {
	Dialog,
	DialogContent,
	dialogCardBackdropClassName,
	dialogCardClassName,
} from '@shared/ui/dialog';
import { cn } from '@/lib/utils';
import { useT } from '@shared/i18n';

/**
 * Moved out of `views/home/Home.tsx` (improvements/07-template-architecture.md's
 * `views/` sort, user directive 2026-08-16) -- shared between `poets`
 * (internal use inside its own Home page) and `sections` (external import).
 */
export const LogOutDialog = ({
	show,
	setShowLogout,
	onClickLogOut,
}: LogOutDialogProps) => {
	const t = useT();
	const navbarIconUrl = useNavbarIconUrl();
	return (
		<Dialog
			open={show}
			onOpenChange={(open) => {
				if (!open) {
					setShowLogout(false);
				}
			}}
		>
			<DialogContent
				className={cn(
					dialogCardClassName,
					styles['logout-dialog-container'],
				)}
				backdropClassName={dialogCardBackdropClassName}
			>
				<div className={styles['logout-dialog']}>
					<img src={navbarIconUrl} alt={t('common.logo')} />
					<h3>{t('logout.confirm')}</h3>
					<button
						type="button"
						onClick={() => {
							setShowLogout(false);
							onClickLogOut();
						}}
					>
						{t('logout.button')}
					</button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export interface LogOutDialogProps {
	show: boolean;
	setShowLogout: (l: boolean) => void;
	onClickLogOut: () => void;
}

export default LogOutDialog;
